// SPDX-License-Identifier: AGPL-3.0-or-later

import type {IconProps} from '@phosphor-icons/react';
import React from 'react';

export const NoConnectChannelIcon = React.forwardRef<SVGSVGElement, IconProps>(
	({size = 256, className, ...props}, ref) => (
		<svg
			ref={ref}
			width={size}
			height={size}
			viewBox="0 0 256 256"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			className={className}
			aria-hidden={true}
			data-flx="ui.icons.no-connect-channel-icon.svg"
			{...props}
		>
			<path
				fill="currentColor"
				d="M202.136 94.1467h-29.843V71.7644c0-11.8722-4.716-23.2582-13.111-31.6532S139.401 27 127.529 27s-23.258 4.7162-31.6534 13.1112c-8.3949 8.395-13.1112 19.781-13.1112 31.6532v22.3823H52.9215c-3.9574 0-7.7528 1.572-10.5511 4.3704C39.5721 101.315 38 105.111 38 109.068v104.451c0 3.957 1.5721 7.752 4.3704 10.551 2.7983 2.798 6.5937 4.37 10.5511 4.37H202.136c3.958 0 7.753-1.572 10.551-4.37 2.799-2.799 4.371-6.594 4.371-10.551V109.068c0-3.957-1.572-7.753-4.371-10.5509-2.798-2.7984-6.593-4.3704-10.551-4.3704m-74.607 78.3373c-2.214 0-4.377-.656-6.218-1.886-1.84-1.229-3.274-2.977-4.121-5.022s-1.069-4.295-.637-6.466 1.497-4.165 3.063-5.73c1.565-1.565 3.559-2.631 5.73-3.063 2.17-.432 4.421-.21 6.466.637 2.044.847 3.792 2.282 5.022 4.122s1.886 4.004 1.886 6.217c0 2.968-1.179 5.815-3.278 7.914-2.099 2.098-4.945 3.277-7.913 3.277m29.843-78.3373H97.6859V71.7644c0-7.9148 3.1441-15.5055 8.7411-21.1021 5.596-5.5967 13.187-8.7408 21.102-8.7408s15.505 3.1441 21.102 8.7408c5.597 5.5966 8.741 13.1873 8.741 21.1021z"
				data-flx="ui.icons.no-connect-channel-icon.path"
			/>
		</svg>
	),
);
